"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
function assert(condition, message) {
    if (!condition) {
        throw new Error(message || 'Assertion failed');
    }
}
exports.assert = assert;
function isScalar(x) {
    return Buffer.isBuffer(x) && x.length === 32;
}
exports.isScalar = isScalar;
function isValidPrivateKey(privateKey) {
    if (!isScalar(privateKey)) {
        return false;
    }
    return (privateKey.compare(constants_1.ZERO32) > 0 && privateKey.compare(constants_1.EC_GROUP_ORDER) < 0);
}
exports.isValidPrivateKey = isValidPrivateKey;
function equalConstTime(b1, b2) {
    if (b1.length !== b2.length) {
        return false;
    }
    let res = 0;
    for (let i = 0; i < b1.length; i++) {
        res |= b1[i] ^ b2[i];
    }
    return res === 0;
}
exports.equalConstTime = equalConstTime;
function isValidKeyLength(length) {
    return !(length <= constants_1.LENGTH_0 ||
        length > constants_1.MAX_KEY_LENGTH ||
        parseInt(String(length)) !== length);
}
exports.isValidKeyLength = isValidKeyLength;
//# sourceMappingURL=validators.js.map